import {webRequest, webNoTokenRequest} from '../api'

// 快速鍵群
export function createHouseGroup() {
    return webRequest({
        url:'/v1/oauth/management/house/group/create/automatically',
        method:'get',
    })
}
// 房源群組列表
export function getHouseGroupList() {
    return webRequest({
        url:'/v1/oauth/management/house/group/list',
        method:'get',
    })
}
// 編輯房源群組列表
export function getEditHouseGroupList(params) {
    return webRequest({
        url:'/v1/oauth/management/house/group/houseOption',
        method:'get',
        params: params,
    })
}
// 編輯房源群組
export function editHouseGroup(data) {
    return webRequest({
        url:'/v1/oauth/management/house/group/edit',
        method:'post',
        data: data,
    })
}
// 刪除房源群組
export function apiBizDelHouseGroup(data) {
    return webRequest({
        url:'/v1/oauth/management/house/group/delete',
        method:'post',
        data: data,
    })
}


// WEBPACK FOOTER //
// ./src/apis/company/houseGroup.js